import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
} from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { environment } from 'src/environments/environment';
import { PAGE_SIZE, MAX_SIZE } from 'src/app/onelog/common/config/common';
import { TIMESHEET } from 'src/app/onelog/common/config/url';
import { DateSelectComponent } from 'src/app/onelog/common/fields/date-select/date-select.component';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-timesheet',
  templateUrl: './timesheet.component.html',
  styleUrls: ['./timesheet.component.css'],
})
export class TimesheetComponent implements OnInit {
  @ViewChildren(DateSelectComponent) NgbDate: QueryList<DateSelectComponent>;

  constructor(
    private _requestService: RequestService,
    private cdr: ChangeDetectorRef
  ) {}

  apiURL = environment.sachWebURL;
  selectedproductId: string = '';
  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  selectStarFilterDate: any = [];
  selectEndFilterDate: any = [];
  successToastShow: boolean = false;

  ngOnInit(): void {
    // this.loadProducts(this.createPostData());
    // this.dropdownListBookType = NEW_DROP_DOWN_LIST_BOOK_TYPE;
  }

  loadProducts(postData: any = [], url: string = TIMESHEET) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = data;
        //this.totalProducts = data[0].Total_Rows;
        this.perPage = 25;
        this.lastPage = Math.floor(this.totalProducts / 25) + 1;
        //this.currentPage = this.responseData.current_page;
        console.log(this.products);
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  createPostData() {
    return {
      selectedStartDate: Object.assign({}, this.selectStarFilterDate),
      selectedEndDate: Object.assign({}, this.selectEndFilterDate),
      page: this.currentPage,
    };
  }

  downloadReport() {
    if (this.selectStarFilterDate['date'] && this.selectEndFilterDate['date']) {
      console.log('download true');
      this._requestService.download(
        TIMESHEET,
        {
          is_download: 1,
          selectedStartDate: Object.assign({}, this.selectStarFilterDate),
          selectedEndDate: Object.assign({}, this.selectEndFilterDate),
          page: this.currentPage,
        },
        '',
        'timesheet_report'
      );
    } else {
      console.log('download false');
      this.successToastShow = true;
    }
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log({
      selectedStartDate: Object.assign({}, this.selectStarFilterDate),
      selectedEndDate: Object.assign({}, this.selectEndFilterDate),
      page: this.currentPage,
    });

    if (this.selectStarFilterDate['date'] && this.selectEndFilterDate['date']) {
      console.log('true');
      this.loadProducts(this.createPostData());
    } else {
      console.log('false');
      this.successToastShow = true;
      this.searchBtnText = 'Search';
      this.showSearchLoading = false;
    }
    //this.loadProducts(this.createPostData());
  }

  updateSelectedDate(event: any) {
    console.log(event);

    if (event.type == 'startDate') {
      this.selectStarFilterDate['date'] = event.dateString;
    }

    if (event.type == 'endDate') {
      this.selectEndFilterDate['date'] = event.dateString;
    }
    console.log(this.selectStarFilterDate, this.selectEndFilterDate);
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }

  clearFilters() {
    this.clearAllDates();
    this.selectStarFilterDate = [];
    this.selectEndFilterDate = [];
  }

  clearAllDates(): void {
    this.NgbDate.forEach((datePickerComp) => {
      datePickerComp.clearDate();
    });
  }

  assignTotalValue(value: any) {
    this.totalProducts = value;
  }
}
